import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Slice } from 'gatsby';

import { SideNav } from '@lanl-web/lanl-components';
import { WMSideNav } from './WMSideNav';

import './layout.scss';

const Layout = ({ children, className, location }) => {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <>
      <Slice alias='header' />
      <div className='layout-body'>
        <SideNav
          location={location}
          setShowMenu={setShowMenu}
          showMenu={showMenu}
        >
          <WMSideNav location={location} setShowMenu={setShowMenu} />
        </SideNav>
        <main className={className}>{children}</main>
      </div>
      <Slice alias='footer' />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  location: PropTypes.object,
};

export default Layout;
